module.exports = __webpack_public_path__ + "img/transfer-icon-primary.4c3c2f93.svg";